import Svg from '@app/components/svg';

const Folders = Svg(
  <>
    <path
      d="M118.039 10.6252C119.611 4.75705 125.643 1.27465 131.511 2.84701L142.363 5.75477C144.662 6.37078 146.699 7.71582 148.169 9.58801L150.096 12.044C151.583 13.938 153.65 15.2918 155.98 15.8979L187.735 24.1568C193.645 25.6939 197.172 31.7509 195.591 37.6496L188.352 64.668C186.779 70.5361 180.748 74.0185 174.88 72.4462L117.016 56.9418C111.148 55.3694 107.666 49.3377 109.238 43.4696L118.039 10.6252Z"
      fill="#D6DFE2"
    />
    <rect
      x="117.987"
      y="10.8191"
      width="81.9044"
      height="56.003"
      rx="11"
      transform="rotate(15 117.987 10.8191)"
      fill="#E6EBED"
    />
    <path
      d="M1.98466 78.6554C0.888561 72.68 4.84405 66.9474 10.8195 65.8513L25.5945 63.141C27.9355 62.7116 30.3527 63.0531 32.4831 64.1141L36.6521 66.1905C38.8074 67.2639 41.2553 67.6005 43.6202 67.1487L82.6845 59.6857C88.6828 58.5398 94.4663 62.4991 95.5681 68.5056L101.935 103.216C103.031 109.191 99.0758 114.924 93.1003 116.02L22.401 128.989C16.4256 130.085 10.693 126.129 9.59687 120.154L1.98466 78.6554Z"
      fill="#D6DFE2"
    />
    <rect
      x="2.31641"
      y="80.4634"
      width="93.8789"
      height="64.1907"
      rx="11"
      transform="rotate(-10.3944 2.31641 80.4634)"
      fill="#E6EBED"
    />
    <path
      d="M71.3579 101.414C73.3963 95.6906 79.6882 92.7038 85.4111 94.7422L99.5618 99.7826C101.804 100.581 103.726 102.086 105.041 104.07L107.613 107.952C108.943 109.96 110.895 111.475 113.169 112.266L150.731 125.335C156.498 127.342 159.528 133.663 157.478 139.415L145.637 172.659C143.599 178.382 137.307 181.368 131.584 179.33L63.8724 155.212C58.1494 153.173 55.1626 146.881 57.201 141.158L71.3579 101.414Z"
      fill="#8EC4E3"
    />
    <rect
      x="70.7412"
      y="103.145"
      width="93.879"
      height="64.1907"
      rx="11"
      transform="rotate(19.6056 70.7412 103.145)"
      fill="#D3E8F4"
    />
    <path
      d="M88.4324 32.8595L86.8926 34.3994L89.4132 36.9201L90.9531 35.3802L88.4324 32.8595Z"
      fill="#99B0B7"
    />
    <path
      d="M94.6063 39.0329L93.0664 40.5728L95.5871 43.0934L97.1269 41.5535L94.6063 39.0329Z"
      fill="#99B0B7"
    />
    <path
      d="M95.5807 32.8572L93.0586 35.3794L94.5975 36.9183L97.1197 34.3962L95.5807 32.8572Z"
      fill="#99B0B7"
    />
    <path
      d="M89.404 39.0345L86.8818 41.5566L88.4208 43.0956L90.9429 40.5734L89.404 39.0345Z"
      fill="#99B0B7"
    />
    <path
      d="M66.5055 34.8263L66.5049 37.0159L68.6944 37.0152L68.6951 34.8257L66.5055 34.8263Z"
      fill="#99B0B7"
    />
    <path
      d="M61.4727 39.8918L61.4717 42.0813L63.6612 42.081L63.6623 39.8915L61.4727 39.8918Z"
      fill="#99B0B7"
    />
    <path
      d="M61.4903 29.7699L61.4893 31.9595L63.6788 31.9592L63.6798 29.7697L61.4903 29.7699Z"
      fill="#99B0B7"
    />
    <path
      d="M56.4268 34.84L56.4258 37.0295L58.6153 37.0293L58.6164 34.8397L56.4268 34.84Z"
      fill="#99B0B7"
    />
    <path
      d="M65.9764 37.7855L64.4277 39.3342L65.9755 40.882L67.5242 39.3333L65.9764 37.7855Z"
      fill="#99B0B7"
    />
    <path
      d="M58.8466 37.8055L57.2979 39.3542L58.8456 40.902L60.3943 39.3533L58.8466 37.8055Z"
      fill="#99B0B7"
    />
    <path
      d="M65.9969 30.6547L64.4482 32.2034L65.996 33.7511L67.5447 32.2024L65.9969 30.6547Z"
      fill="#99B0B7"
    />
    <path
      d="M58.8485 30.6571L57.2998 32.2058L58.8476 33.7536L60.3963 32.2049L58.8485 30.6571Z"
      fill="#99B0B7"
    />
    <path
      d="M57.8822 7.60149L57.8816 9.77784L61.4027 9.77679L58.9159 12.2636L60.4548 13.8025L62.9416 11.3157L62.9405 14.8368L65.1169 14.8362L65.118 11.315L67.6032 13.8003L69.1431 12.2605L66.6578 9.7752L70.1789 9.77414L70.1796 7.59776L66.6585 7.59881L69.1453 5.11205L67.6063 3.57312L65.1196 6.05989L65.1206 2.53878L62.9442 2.53944L62.9432 6.06056L60.4579 3.57529L58.9181 5.11513L61.4033 7.6004L57.8822 7.60149ZM61.4387 7.6181L62.952 6.10478L65.093 6.10415L66.6054 7.61653L66.6048 9.75751L65.0914 11.2708L62.9505 11.2715L61.4381 9.75909L61.4387 7.6181Z"
      fill="#99B0B7"
    />
    <path
      d="M144.717 195.639L144.716 199.205L146.893 199.204L146.894 195.638L144.717 195.639Z"
      fill="#99B0B7"
    />
    <path
      d="M144.707 204.385L144.706 207.951L146.883 207.95L146.884 204.384L144.707 204.385Z"
      fill="#99B0B7"
    />
    <path
      d="M148.409 200.709L148.408 202.886L151.974 202.885L151.975 200.708L148.409 200.709Z"
      fill="#99B0B7"
    />
    <path
      d="M139.663 200.704L139.662 202.881L143.228 202.88L143.229 200.703L139.663 200.704Z"
      fill="#99B0B7"
    />
    <path
      d="M117.521 201.825L117.52 204.014L119.709 204.014L119.71 201.825L117.521 201.825Z"
      fill="#99B0B7"
    />
    <path
      d="M112.466 206.89L112.466 209.08L114.655 209.079L114.656 206.89L112.466 206.89Z"
      fill="#99B0B7"
    />
    <path
      d="M112.483 196.77L112.482 198.959L114.672 198.959L114.673 196.77L112.483 196.77Z"
      fill="#99B0B7"
    />
    <path
      d="M107.42 201.84L107.419 204.03L109.608 204.029L109.61 201.84L107.42 201.84Z"
      fill="#99B0B7"
    />
    <path
      d="M163.259 182.071L161.71 183.62L163.258 185.168L164.806 183.619L163.259 182.071Z"
      fill="#99B0B7"
    />
    <path
      d="M156.119 182.082L154.57 183.631L156.118 185.179L157.667 183.63L156.119 182.082Z"
      fill="#99B0B7"
    />
    <path
      d="M163.269 174.932L161.721 176.48L163.268 178.028L164.817 176.48L163.269 174.932Z"
      fill="#99B0B7"
    />
    <path
      d="M156.121 174.934L154.572 176.483L156.12 178.03L157.669 176.482L156.121 174.934Z"
      fill="#99B0B7"
    />
  </>,
  {
    viewBox: '0 0 200 211',
    fill: 'none',
  },
);

Folders.displayName = 'Folders';

export default Folders;
